// Module
var code = "<div class=\"offer-countdown\"> <div class=\"offer-countdown__clock\"> <span ng-bind-html=\"$ctrl.offerMessage\"></span> </div> <div class=\"offer-countdown__flag\">-{{$ctrl.discount}}%</div> <buy-button class=\"offer-countdown__buy\" p-id=\"::$ctrl.pId\" p-type=\"::$ctrl.pType\" on-price-loaded=\"$ctrl.onPriceLoaded(price)\"/> </div> ";
// Exports
module.exports = code;